import { AggregationMethod, AggregationSelector } from "~/components/reusable/AggregationSelector"
import { useProductTableAggregations } from "~/hooks/useProductTable"

export const CUSTOMER_AGGREGATION_METHODS: AggregationMethod[] = [
  AggregationMethod.Customer,
  AggregationMethod.ProductName,
  AggregationMethod.Variant,
  AggregationMethod.Country,
  AggregationMethod.City,
  AggregationMethod.ZipCode,
  AggregationMethod.CustomerType,
]

const SECONDARY_OPTIONS: AggregationMethod[] = [
  AggregationMethod.ProductName,
  AggregationMethod.Variant,
]

type Props = {
  tableId: string
}

export const CustomerAggregationOptions = ({ tableId }: Props) => {
  const [aggregations, setAggregations] = useProductTableAggregations(tableId)
  const primary = (aggregations[0] ?? AggregationMethod.Customer) as AggregationMethod
  const secondary = aggregations[aggregations.length - 1] as AggregationMethod | undefined

  const showSecondary =
    aggregations.length > 1 &&
    primary !== AggregationMethod.ProductName &&
    primary !== AggregationMethod.Variant

  const handleChange = (method: AggregationMethod, level: 0 | 1) => {
    if (level === 1) {
      const next = [...aggregations]
      next[aggregations.length - 1] = method
      setAggregations(next)
      return
    }

    switch (method) {
      case AggregationMethod.Customer:
        setAggregations([AggregationMethod.Customer, AggregationMethod.Variant])
        return
      case AggregationMethod.Variant:
      case AggregationMethod.ProductName:
        setAggregations([method, AggregationMethod.Customer])
        return
      case AggregationMethod.Country:
      case AggregationMethod.City:
      case AggregationMethod.ZipCode:
        setAggregations([method, AggregationMethod.Customer, AggregationMethod.Variant])
        return
      default:
        setAggregations([method])
    }
  }

  return (
    <>
      <div className="flex flex-row items-center justify-between gap-2">
        <span className="label-base">Group rows by</span>
        <AggregationSelector
          prefix=""
          selectedMethod={primary}
          aggregationMethods={CUSTOMER_AGGREGATION_METHODS}
          onSelect={(m) => handleChange(m as AggregationMethod, 0)}
        />
      </div>
      {showSecondary && secondary && (
        <div className="flex flex-row items-center justify-between gap-2">
          <span className="label-base text-fg-subtle">and</span>
          <AggregationSelector
            prefix=""
            selectedMethod={secondary}
            aggregationMethods={SECONDARY_OPTIONS}
            onSelect={(m) => handleChange(m as AggregationMethod, 1)}
          />
        </div>
      )}
    </>
  )
}
